module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('login', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentView == 'login'),
      expression: "currentView=='login'"
    }],
    ref: "login",
    on: {
      "changeToVerify": _vm.changeToVerify,
      "changeToError": _vm.changeToError,
      "changeToMode": _vm.changeToMode
    }
  }), _vm._v(" "), (_vm.currentView == 'verify') ? _c('verify', {
    attrs: {
      "un": _vm.un,
      "ppdata": _vm.ppdata
    },
    on: {
      "changeToLogin": _vm.changeToLogin
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentView == 'error') ? _c('errorpage', {
    attrs: {
      "errMsg": _vm.errMsg
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentView === 'mode') ? _c('mode', {
    attrs: {
      "mode": _vm.modeData,
      "toUrl": _vm.toUrl
    },
    on: {
      "backLogin": _vm.changeToLogin
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc235ee6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 523
// module chunks = 1